export const formatDocumentDate = (dateString) => {
  if (!dateString) {
    return "Last opened";
  }

  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return "Last opened";
    }

    const options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    
    const formattedDate = date.toLocaleDateString('en-US', options);
    return `Last update · ${formattedDate}`;
  } catch (error) {
    console.error('Error formatting document date:', error);
    return "Last opened";
  }
};

const MS_PER_MINUTE = 60 * 1000;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export const formatTimeAgo = (dateInput) => {
  if (!dateInput) return '';
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (Number.isNaN(date.getTime())) return '';
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / MS_PER_MINUTE);
  const diffHours = Math.floor(diffMs / MS_PER_HOUR);
  const diffDays = Math.floor(diffMs / MS_PER_DAY);
  if (diffMins < 60) return `${diffMins} mins ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};
